<template>
  <div class="event" :style="eventScaleStyle">
    <div v-if="!timeList.length" class="event__empty">
      <p>暂无关联事件数据</p>
    </div>

    <el-scrollbar
      v-if="lines > 0"
      ref="scrollArea"
      class="event__scroll"
    >
      <div class="event__canvas">
        <div class="event__lines">
          <div v-for="(item, index) in lines" :key="index">
            <div v-if="index === 0" class="first_backgroud" />
            <div v-else-if="index === lines - 1" class="end_backgroud" />
            <div v-else class="center_backgroud" />
          </div>
        </div>

        <div class="event__arcs">
          <div
            v-for="(item, index) in lines"
            :key="index"
            class="event__arc-row"
            :class="{ 'event__arc-row--reverse': index % 2 !== 0 }"
          >
            <div
              v-if="index !== 0"
              class="half-right-circle"
              :class="[
                index % 2 === 0 ? 'half-left-circle' : 'half-right-circle',
                index !== 1 ? 'half-circle--overlap' : ''
              ]"
            />
          </div>
        </div>

        <div
          v-for="(eventLinesitem, eventLinesLine) in eventLines"
          :key="eventLinesLine + 'eventLinesitem'"
        >
          <div v-if="eventLinesLine === 0" class="event__first-row">
            <div class="first-item-backgroud-new">
              <div class="first-item-new-wrap">
                <div class="first-item-new" :class="{ 'first-item-new--default': !person.img }">
                  <img :src="person.img || defaultCover" class="first-item-backgroud-img">
                </div>
              </div>

              <div class="first-center-item-content-other">
                <span class="center-item-content-title event-person__title">
                  {{ person.name }}
                </span>
                <span class="center-item-content-info-five event-person__info">
                  {{ person.info || '-' }}
                </span>
              </div>
            </div>

            <div
              v-for="(itemFirst, indexFirst) in eventLines.length > 1 ? 3 : timeList.length"
              :key="itemFirst + 'itemFirst'"
              @click="clickItemEvent(indexFirst)"
            >
              <div :ref="timeList[indexFirst].date" class="center-item">
                <div :class="indexFirst % 2 === 0 ? 'center-item-content' : 'center-item-content-other'">
                  <span class="center-item-content-title">
                    {{ timeList[indexFirst].year }}
                  </span>
                  <span class="center-item-content-subtitle">
                    {{ timeList[indexFirst].name }}
                  </span>
                  <span class="center-item-content-info">
                    {{ timeList[indexFirst].eventSummary }}
                  </span>
                  <div class="center-item-content-tip">
                    <span class="event__link-icon" @click.stop="eventClick(timeList[indexFirst])" />
                  </div>
                </div>
                <div class="center-item-date">
                  <div class="circle" />
                  <span class="event-date">{{ timeList[indexFirst].date }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else-if="eventLinesLine % 2 === 0 && eventLinesLine === (eventLines.length - 1)"
            class="last-line"
          >
            <div class="last-line-right-circly" />

            <div
              v-for="(itemThirdLast, indexThirdLast) in (timeList.length - eventLinesLine * 3)"
              :key="itemThirdLast + 'itemSecond'"
              class="event__row-flex"
              @click="clickItemEvent(indexThirdLast + eventLinesLine * 3)"
            >
              <div
                :ref="timeList[indexThirdLast + eventLinesLine * 3].date"
                class="center-item"
                :class="{ 'center-item--indent-last': indexThirdLast === 0 }"
              >
                <div :class="indexThirdLast % 2 === 1 ? 'center-item-content' : 'center-item-content-other'">
                  <span class="center-item-content-title">
                    {{ timeList[indexThirdLast + eventLinesLine * 3].year }}
                  </span>
                  <span class="center-item-content-subtitle">
                    {{ timeList[indexThirdLast + eventLinesLine * 3].name }}
                  </span>
                  <span class="center-item-content-info">
                    {{ timeList[indexThirdLast + eventLinesLine * 3].eventSummary }}
                  </span>
                  <div class="center-item-content-tip">
                    <span
                      class="event__link-icon"
                      @click.stop="eventClick(timeList[indexThirdLast + eventLinesLine * 3])"
                    />
                  </div>
                </div>
                <div class="center-item-date">
                  <div class="circle" />
                  <span class="event-date">
                    {{ timeList[indexThirdLast + eventLinesLine * 3].date }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else-if="eventLinesLine % 2 === 0 && eventLinesLine !== (eventLines.length - 1)"
            class="third-line"
          >
            <div class="third-line-right-circly" />

            <div
              v-for="(itemThird, indexThird) in 3"
              :key="itemThird + 'itemThird'"
              @click="clickItemEvent(indexThird + eventLinesLine * 3)"
            >
              <div
                :ref="timeList[indexThird + eventLinesLine * 3].date"
                class="center-item"
                :class="{ 'center-item--indent-third': indexThird === 0 }"
              >
                <div :class="indexThird % 2 === 1 ? 'center-item-content' : 'center-item-content-other'">
                  <span class="center-item-content-title">
                    {{ timeList[indexThird + eventLinesLine * 3].year }}
                  </span>
                  <span class="center-item-content-subtitle">
                    {{ timeList[indexThird + (eventLinesLine) * 3].name }}
                  </span>
                  <span class="center-item-content-info">
                    {{ timeList[indexThird + (eventLinesLine) * 3].eventSummary }}
                  </span>
                  <div class="center-item-content-tip">
                    <span
                      class="event__link-icon"
                      @click.stop="eventClick(timeList[indexThird + (eventLinesLine) * 3])"
                    />
                  </div>
                </div>
                <div class="center-item-date">
                  <div class="circle" />
                  <span class="event-date">
                    {{ timeList[indexThird + (eventLinesLine) * 3].date }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else-if="eventLinesLine % 2 === 1 && eventLinesLine !== (eventLines.length - 1)"
            class="four-line"
          >
            <div class="four-line-right-circly" />

            <div
              v-for="(itemFour, indexFour) in 3"
              :key="itemFour + 'itemFour'"
              @click="clickItemEvent(indexFour + eventLinesLine * 3)"
            >
              <div
                :ref="timeList[indexFour + eventLinesLine * 3].date"
                class="center-item"
                :class="{ 'center-item--indent-four': indexFour === 0 }"
              >
                <div :class="indexFour % 2 === 0 ? 'center-item-content' : 'center-item-content-other'">
                  <span class="center-item-content-title">
                    {{ timeList[indexFour + eventLinesLine * 3].year }}
                  </span>
                  <span class="center-item-content-subtitle">
                    {{ timeList[indexFour + (eventLinesLine) * 3].name }}
                  </span>
                  <span class="center-item-content-info">
                    {{ timeList[indexFour + (eventLinesLine) * 3].eventSummary }}
                  </span>
                  <div class="center-item-content-tip">
                    <span
                      class="event__link-icon"
                      @click.stop="eventClick(timeList[indexFour + (eventLinesLine) * 3])"
                    />
                  </div>
                </div>
                <div class="center-item-date center-item-date--reverse">
                  <span class="event-date event-date--reverse">
                    {{ timeList[indexFour + eventLinesLine * 3].date }}
                  </span>
                  <div class="circle" />
                </div>
              </div>
            </div>
          </div>

          <div
            v-else-if="eventLinesLine % 2 === 1 && eventLinesLine === (eventLines.length - 1)"
            class="four-line"
          >
            <div class="four-line-right-circly" />

            <div
              v-for="(itemFour, indexFour) in (timeList.length - eventLinesLine * 3)"
              :key="itemFour + 'itemFour'"
              @click="clickItemEvent(indexFour + eventLinesLine * 3)"
            >
              <div
                :ref="timeList[indexFour + eventLinesLine * 3].date"
                class="center-item"
                :class="{ 'center-item--indent-four': indexFour === 0 }"
              >
                <div :class="indexFour % 2 === 0 ? 'center-item-content' : 'center-item-content-other'">
                  <span class="center-item-content-title">
                    {{ timeList[indexFour + eventLinesLine * 3].year }}
                  </span>
                  <span class="center-item-content-subtitle">
                    {{ timeList[indexFour + (eventLinesLine) * 3].name }}
                  </span>
                  <span class="center-item-content-info">
                    {{ timeList[indexFour + (eventLinesLine) * 3].eventSummary }}
                  </span>
                  <div class="center-item-content-tip">
                    <span
                      class="event__link-icon"
                      @click.stop="eventClick(timeList[indexFour + (eventLinesLine) * 3])"
                    />
                  </div>
                </div>
                <div class="center-item-date center-item-date--reverse">
                  <span class="event-date event-date--reverse">
                    {{ timeList[indexFour + eventLinesLine * 3].date }}
                  </span>
                  <div class="circle" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { EVENT_DESIGN_REM_RATIO } from '@/config/eventDesign'
import defaultCover from '@/assets/default-cover-square.png'

export default {
  name: 'EventView',
  props: {
    person: {
      type: Object,
      default: () => ({ name: '', img: '', info: '' })
    },
    eventListData: {
      type: Array,
      default: () => []
    },
    coordinate: {
      type: Array,
      default: () => []
    },
    remRatio: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      currentIndex: 0,
      lines: 0,
      eventLines: [],
      timeList: [],
      eventRemRatio: EVENT_DESIGN_REM_RATIO,
      defaultCover
    }
  },
  computed: {
    eventScaleStyle() {
      const ratio = this.remRatio != null ? this.remRatio : this.eventRemRatio
      return {
        '--event-rem-ratio': ratio
      }
    }
  },
  watch: {
    eventListData: {
      handler(val) {
        this.timeList = Array.isArray(val) ? val.slice() : []
      },
      immediate: true,
      deep: true
    },
    timeList: {
      handler(val) {
        if (!val.length) {
          this.lines = 0
          this.eventLines = []
          return
        }
        const nodeLines = Math.ceil(val.length / 3)
        const list = []
        for (let i = 0; i < nodeLines; i += 1) {
          list.push({ index: i, height: 0 })
        }
        this.lines = nodeLines % 2 === 1 ? nodeLines : nodeLines + 1
        this.$nextTick(() => {
          this.eventLines = list
        })
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() {
    const scrollArea = this.$refs.scrollArea
    if (!scrollArea || !scrollArea.$el) {
      return
    }
    const container = scrollArea.$el.querySelector('.el-scrollbar__wrap')
    if (container) {
      container.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      const scrollArea = this.$refs.scrollArea
      if (!scrollArea || !scrollArea.$el || !this.timeList.length) {
        return
      }
      const container = scrollArea.$el.querySelector('.el-scrollbar__wrap')
      const line = parseInt(scrollTop * this.lines / container.scrollHeight, 10)
      const year = this.timeList[line * 3] && this.timeList[line * 3].date
      if (!year) {
        return
      }
      this.currentIndex = this.coordinate.findIndex((item) => {
        return parseInt(year, 10) <= parseInt(item.split('-')[1], 10)
      })
    },
    clickItemEvent(index) {
      const item = this.timeList[index]
      if (!item || !item.id) {
        return
      }
      this.$router.push(`/knowledge/shijian/${item.id}`)
    },
    eventClick(item) {
      if (!item || !item.id) {
        return
      }
      this.$router.push(`/knowledge/shijian/${item.id}`)
    },
    startScrollView(item, index) {
      this.currentIndex = index
      const years = item.split('-')
      for (let i = parseInt(years[0], 10); i < parseInt(years[1], 10); i += 1) {
        const targetIndex = this.timeList.findIndex((entry) => i === parseInt(entry.date, 10))
        if (targetIndex > -1) {
          const refs = this.$refs[this.timeList[targetIndex].date]
          const targetElement = Array.isArray(refs) ? refs[0] : refs
          if (targetElement) {
            this.$nextTick(() => {
              const scrollArea = this.$refs.scrollArea
              if (!scrollArea || !scrollArea.$el) {
                return
              }
              const container = scrollArea.$el.querySelector('.el-scrollbar__wrap')
              const rect = targetElement.getBoundingClientRect()
              const containerRect = container.getBoundingClientRect()
              container.scrollTop = rect.top - containerRect.top + container.scrollTop
            })
            break
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/event-design.scss";
.event {
  width: 100%;
  min-height: event-rem(64);
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: event-rem(8.2);
  background: $color-white;
  border-radius: event-rem(0.4);
  border: 1px solid rgba($color-border, 0.45);
  overflow: hidden;
}

.event__empty {
  min-height: event-rem(32);
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin: 0;
    font-size: event-rem(1.4);
    color: $color-text-light;
  }
}

.event__scroll {
  padding-top: event-rem(4.6);
}

.event__canvas {
  position: relative;
  width: event-rem(150.6);
  height: 100%;
  padding-bottom: event-rem(2);
  overflow: hidden;
}

.event__lines {
  position: absolute;
  top: 0;
  left: 0;
}

.event__arcs {
  position: absolute;
  top: event-rem(24);
  left: 0;
  right: 0;
}

.event__arc-row {
  display: flex;
  width: 100%;

  &--reverse {
    flex-direction: row-reverse;
  }
}

.event__first-row {
  display: flex;
}

.event__row-flex {
  display: flex;
}

.event__link-icon {
  display: inline-block;
  width: event-rem(1.4);
  height: event-rem(1.4);
  margin-left: event-rem(0.5);
  border: 1px solid rgba($color-brown-dark, 0.35);
  border-radius: 50%;
  cursor: pointer;
  position: relative;

  &::after {
    content: '>';
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: event-rem(1);
    color: $color-brown-dark;
    line-height: 1;
  }

  &:hover {
    border-color: $success-color;
    background: rgba($success-color, 0.08);
  }
}

::-webkit-scrollbar {
  display: none;
}

* {
  scrollbar-width: none;
}

.first_backgroud {
  width: event-rem(128.6);
  height: event-rem(2.4);
  margin-top: event-rem(24);
  background: linear-gradient(270deg, $warning-color 1%, $color-white 100%);
}

.end_backgroud {
  width: event-rem(145.6);
  height: event-rem(2.4);
  margin-top: event-rem(24.1);
  margin-left: event-rem(23);
  background: linear-gradient(270deg, $color-white 10%, $warning-color 100%);
}

.center_backgroud {
  width: event-rem(105.6);
  height: event-rem(2.4);
  margin-top: event-rem(24);
  margin-left: event-rem(23);
  background: linear-gradient(to right, $warning-color, $warning-color);
}

.half-right-circle {
  width: event-rem(14.4);
  height: event-rem(28.8);
  margin-right: event-rem(7.6);
  border-radius: 0 event-rem(14.4) event-rem(14.4) 0;
  border-width: event-rem(2.4);
  border-style: solid;
  border-left-width: 0;
  border-color: $warning-color;
  box-sizing: border-box;
  overflow: hidden;
}

.half-left-circle {
  width: event-rem(14.4);
  height: event-rem(28.8);
  margin-left: event-rem(8.6);
  border-radius: event-rem(14.4) 0 0 event-rem(14.4);
  box-sizing: border-box;
  border-width: event-rem(2.4);
  border-style: solid;
  border-right-width: 0;
  border-color: $warning-color;
  overflow: hidden;
}

.half-circle--overlap {
  margin-top: event-rem(-2.4);
}

.first-item-backgroud-new {
  display: flex;
  background: linear-gradient(240deg, $color-white 1%, $color-paper-light 78%);
  width: event-rem(51.5);
  margin-left: event-rem(-2);
  height: event-rem(24);
}

.first-item-new-wrap {
  width: event-rem(27.3);
}

.first-item-new {
  display: flex;
  align-items: center;
  justify-content: center;
  width: event-rem(27.3);
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: $color-paper-light;
  clip-path: polygon(0% 0%, #{event-rem(23.3)} 0%, 100% 100%, 0% 100%);

  &--placeholder {
    background: linear-gradient(135deg, $color-paper-light, $color-cream);
  }
}

.first-item-backgroud-img {
  position: absolute;
  left: 0;
  bottom: 0;
  width: event-rem(26.3);
  height: 100%;
  object-fit: cover;
  background-color: $color-brown-dark;
  clip-path: polygon(0% 0%, #{event-rem(23.3)} 0%, 100% 100%, 0% 100%);
}

.first-center-item-content-other {
  width: event-rem(24.7);
  height: event-rem(24);
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: event-rem(1.9);
  box-sizing: border-box;
}

.circle {
  width: event-rem(1);
  height: event-rem(1);
  background: $success-color;
  border-radius: 50%;
}

.center-item {
  width: event-rem(25);
  margin-left: event-rem(2.6);
  position: relative;

  &--indent-last {
    margin-left: event-rem(32.8);
  }

  &--indent-third {
    margin-left: event-rem(15);
  }

  &--indent-four {
    margin-right: event-rem(14.4);
  }
}

.center-item-date {
  display: flex;
  align-items: center;
  height: event-rem(2.4);

  &--reverse {
    flex-direction: row-reverse;
  }
}

.center-item-content {
  width: event-rem(25);
  height: event-rem(24);
  display: flex;
  flex-direction: column;
  position: relative;
  background: $color-cream;
  border: 1px solid rgba($color-border, 0.55);
  border-radius: event-rem(0.4);
  padding-left: event-rem(1.9);
  padding-right: event-rem(1.9);
  box-sizing: border-box;
}

.center-item-content-other {
  width: event-rem(25);
  height: event-rem(24);
  display: flex;
  flex-direction: column;
  position: relative;
  background: $color-white;
  border: 1px solid rgba($color-border, 0.45);
  border-radius: event-rem(0.4);
  padding-left: event-rem(1.9);
  padding-right: event-rem(1.9);
  box-sizing: border-box;
}

.center-item-content-title {
  font-family: $font-serif;
  font-size: event-rem(2);
  color: $color-brown-dark;
  margin-top: event-rem(3);
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.center-item-content-subtitle {
  font-size: event-rem(1.6);
  margin-top: event-rem(1.1);
  color: $color-text;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.center-item-content-info {
  font-size: event-rem(1.4);
  margin-top: event-rem(1.2);
  line-height: event-rem(2.2);
  color: $color-text-light;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.center-item-content-info-five {
  font-size: event-rem(1.4);
  margin-top: event-rem(1.2);
  line-height: event-rem(2.2);
  color: $color-text;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.event-person__title {
  color: $color-text;
}

.event-person__info {
  color: $color-text;
}

.event-date {
  color: $success-color;
  font-size: event-rem(2);
  margin-left: event-rem(0.5);

  &--reverse {
    margin-left: event-rem(0.7);
  }
}

.center-item-content-tip {
  position: absolute;
  right: event-rem(1.9);
  bottom: event-rem(1.1);
}

.third-line {
  position: relative;
  display: flex;
}

.third-line-right-circly {
  position: relative;
  width: event-rem(25.6);
  height: event-rem(23.8);
  margin-left: event-rem(-9.7);
}

.four-line {
  width: event-rem(131.2);
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  margin-left: event-rem(34);
}

.four-line-right-circly {
  position: relative;
  width: event-rem(25.6);
  height: event-rem(23.8);
}

.last-line {
  position: relative;
  display: flex;
}

.last-line-right-circly {
  position: absolute;
  width: event-rem(25.6);
  height: event-rem(23.8);
  left: event-rem(17.3);
}

.scrollbar-flex-content-bottom {
  display: flex;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  background: linear-gradient(0deg, rgba($warning-color, 0.35) -42%, rgba($color-white, 0) 121%);
  padding-top: event-rem(2);
}

.scrollbar-demo-item {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: event-rem(11.8);
  cursor: pointer;
  height: event-rem(8.2);
  text-align: center;
  font-size: event-rem(1.4);
  color: $color-text;
  padding-bottom: event-rem(1.2);
}

.scrollbar-demo-item:hover {
  color: $success-color;
}

.scrollbar-demo-item-back {
  transform: scale(1);
  color: $success-color;
  position: relative;
}

.scrollbar-demo-item-back::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: event-rem(0.5);
  background-color: $success-color;
}
</style>
